import { render, staticRenderFns } from "./LogForm.vue?vue&type=template&id=56d888ff&scoped=true&"
import script from "./LogForm.vue?vue&type=script&lang=js&"
export * from "./LogForm.vue?vue&type=script&lang=js&"
import style0 from "./LogForm.vue?vue&type=style&index=0&id=56d888ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d888ff",
  null
  
)

export default component.exports